import { render, staticRenderFns } from "./LeadershipPlus.vue?vue&type=template&id=0a940d46&scoped=true&"
import script from "./LeadershipPlus.vue?vue&type=script&lang=js&"
export * from "./LeadershipPlus.vue?vue&type=script&lang=js&"
import style0 from "./LeadershipPlus.vue?vue&type=style&index=0&id=0a940d46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a940d46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
